var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden"},[_c('audio',{ref:"Player",attrs:{"loop":""}},[_c('source',{attrs:{"src":"/audio/南屯囝仔_FINAL02.mp3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }